'use client';

import { useIntl } from 'react-intl';

export const BasketEmpty = ({ loggedIn }: { loggedIn?: boolean }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="max-w-[49.625rem]" data-testid="basket-empty-wrapper">
      <div className="mb-6 flex flex-col items-center justify-between text-center">
        <div className="icon-emp-cart size-[5rem]" />
        <div className="text-size-headline-xl md:text-size-headline-2xl mt-2.5 mb-1 md:mb-1.5">
          {formatMessage({
            id: 'BasketEmpty.Headline',
            defaultMessage: 'Dein Warenkorb ist leer',
          })}
        </div>
        <div className="text-size-body-base mb-3.5 md:mb-6">
          {loggedIn &&
            formatMessage({
              id: 'BasketEmpty.LoggedIn.InfoText',
              defaultMessage:
                'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
            })}
          {!loggedIn &&
            formatMessage({
              id: 'BasketEmpty.LoggedOut.InfoText',
              defaultMessage:
                'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
            })}
        </div>
      </div>
    </div>
  );
};
